import React from 'react';
import { MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Home.css';

const LABELS = {
  residential: 'Residential',
  commercial: 'Commercial',
  agricultural: 'Agricultural',
  ddjay_plot: 'DDJAY plot',
  delhi_pooling: 'Delhi land pooling',
  flat: 'Flat',
  acquire_sell: 'Acquire and sell',
  development: 'Development',
};

const formatInr = (v) =>
  v === null || v === undefined || v === '' ? null : `₹${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

// Public (logged-out) card: only fields returned by /api/spvs/public/ — no prices or returns.
const ProjectCard = ({ spv }) => {
  const minimum = formatInr(spv.minimum);
  return (
    <div className="projectCard group">
      <div className="relative overflow-hidden rounded-xl mb-4">
        <img
          src={spv.image || '/hero-land-investment.jpg'}
          alt={`${spv.name} land parcel`}
          loading="lazy"
          className="projectImage"
        />
        <div className="absolute top-3 right-3">
          <span className="badge active">Raising</span>
        </div>
      </div>
      <div className="space-y-4">
        <h3 className="projectTitle">{spv.name}</h3>
        <div className="flex items-center text-muted-foreground mb-3">
          <MapPin className="w-4 h-4 mr-1" aria-hidden="true" />
          <span className="text-sm">{spv.location}</span>
        </div>
        <dl className="grid grid-cols-2 gap-2 text-sm py-3 border-t border-border">
          <dt className="text-muted-foreground">Asset type</dt>
          <dd className="font-semibold">{(spv.asset_types || []).map((t) => LABELS[t] || t).join(', ')}</dd>
          {spv.deal_type && (<><dt className="text-muted-foreground">Deal type</dt><dd className="font-semibold">{LABELS[spv.deal_type] || spv.deal_type}</dd></>)}
          <dt className="text-muted-foreground">Minimum</dt>
          <dd className="font-semibold">{minimum || 'On request'}</dd>
        </dl>
        <Link to="/contact" className="btn-primary block text-center">Request an invite</Link>
      </div>
    </div>
  );
};

export default ProjectCard;
